import { MakeCall } from 'ha/services/apiV2/createMakeCall';
import { ListingExclusion } from './types/Listing';
import { APIV2_URL } from './constants';

interface Query {
  rangeFrom?: string;
  rangeTo?: string;
}

export interface ListingExclusionsResponse {
  rangeFrom: string;
  rangeTo: string;
  dates: ListingExclusion[];
}

export default (makeCall: MakeCall) =>
  (listingId: number, { rangeFrom, rangeTo }: Query = {}) =>
    makeCall<ListingExclusionsResponse>(
      'GET',
      `${APIV2_URL}/listing/${listingId}/exclusions`,
      {
        query: { rangeFrom, rangeTo },
      },
    );
